var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "300px",
        title: "提示",
        "close-on-click-modal": false,
        "show-close": false,
        "destroy-on-close": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c("div", { staticStyle: { "text-align": "center" } }, [
        _vm._v(
          _vm._s(
            _vm.isRight ? "恭喜你，答对了！" : "很遗憾，答错了！请重新学习。"
          )
        )
      ]),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticClass: "submit-btn",
          attrs: { type: "primary" },
          on: { click: _vm.submit }
        },
        [_vm._v(_vm._s(_vm.isRight ? "继续学习" : "重新学习"))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-575d7978", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-575d7978","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/videoDetail/answerResultDialog.vue
// module id = 1578
// module chunks = 0